/*
 *
 * MailConfiguration actions
 *
 */

import {
  GET_CONFIGURATION_WATCHER,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_FAILED,
  GET_IMAGE_LOGO_WATCHER,
  GET_IMAGE_LOGO_SUCCESS,
  GET_IMAGE_LOGO_FAILED,
} from "./constants"

// GET IMAGE LOGO
export function getImageLogoWatcher(payload) {
  return {
    type: GET_IMAGE_LOGO_WATCHER,
    payload,
  }
}

export function getImageLogoSuccess(payload) {
  return {
    type: GET_IMAGE_LOGO_SUCCESS,
    payload,
  }
}

export function getImageLogoFailed(payload) {
  return {
    type: GET_IMAGE_LOGO_FAILED,
    payload,
  }
}

// GET CONFIGURATION
export function getConfigurationWatcher(payload) {
  return {
    type: GET_CONFIGURATION_WATCHER,
    payload,
  }
}

export function getConfigurationSuccess(payload) {
  return {
    type: GET_CONFIGURATION_SUCCESS,
    payload,
  }
}

export function getConfigurationFailed(payload) {
  return {
    type: GET_CONFIGURATION_FAILED,
    payload,
  }
}
